import { onlyDigits } from "../utils/masks";

export type ReferralFieldError =
  | "nameRequired"
  | "nameTooShort"
  | "phoneRequired"
  | "phoneInvalid";

/**
 * Validate referred person name after trim.
 */
export function getReferralNameError(name: string): ReferralFieldError | null {
  const trimmed = name.trim();
  if (!trimmed) return "nameRequired";
  if (trimmed.length < 2) return "nameTooShort";
  return null;
}

/**
 * Validate Brazilian phone (10 landline or 11 mobile digits).
 */
export function getReferralPhoneError(phone: string): ReferralFieldError | null {
  const digits = onlyDigits(phone);
  if (!digits) return "phoneRequired";
  if (digits.length < 10 || digits.length > 11) return "phoneInvalid";
  return null;
}
